
import Vue from 'vue';
import { Data as ArticleData } from '@root/modules/article/types/article';
import LinkHandler from '@core/components/helpers/LinkHandler.vue';
import buildTagUrl from '@root/modules/tags/utils/buildTagUrl';
import { Tag } from '@root/common/types/fragment';

interface Props {
  article: ArticleData;
}

interface Computed {
  items: ArticleData['tags']['items'];
}

interface Methods {
  getTagUrl: (tag: Tag) => string;
}

const hiddenTags = [96603553, 96603555];

export default Vue.extend<unknown, Methods, Computed, Props>({
  components: {
    LinkHandler,
  },
  props: {
    article: {
      type: Object,
      required: true,
    },
  },
  computed: {
    items() {
      return this.$props.article.tags?.items?.filter((tag: ArticleData['tags']['items'][0]) => !hiddenTags.includes(tag.id));
    },
  },
  methods: {
    getTagUrl(tag) {
      const { domain, locale } = this.$channelConfig('settings');
      const fakeDomainEnabled = this.$config.FAKE_DOMAIN_ENABLED;

      return buildTagUrl({ tag, domain, locale, fakeDomainEnabled });
    },
  },
});
